import {barnManagerModule} from '../../index.module';
import {downgradeComponent} from '@angular/upgrade/static';
import {MatMenuComponent} from '@shared-ui/mat-menu/mat-menu.component';
import angular from 'angular';

barnManagerModule.directive('ng2MatMenu', downgradeComponent({ component: MatMenuComponent }) as angular.IDirectiveFactory);
